exports.components = {
  "component---src-templates-business-jsx": () => import("./../../../src/templates/Business.jsx" /* webpackChunkName: "component---src-templates-business-jsx" */),
  "component---src-templates-business-seo-jsx": () => import("./../../../src/templates/BusinessSeo.jsx" /* webpackChunkName: "component---src-templates-business-seo-jsx" */),
  "component---src-templates-default-jsx": () => import("./../../../src/templates/Default.jsx" /* webpackChunkName: "component---src-templates-default-jsx" */)
}

